export default "__VITE_ASSET__D86jcg$G__"